import React from 'react';
import { CheckIcon } from 'lucide-react';
interface OptionButtonProps {
  label: string;
  detail?: string;
  hint?: string;
  selected: boolean;
  onClick: () => void;
}
export function OptionButton({
  label,
  detail,
  hint,
  selected,
  onClick
}: OptionButtonProps) {
  return <button type="button" onClick={onClick} aria-pressed={selected} className={`group flex h-full w-full flex-col items-start gap-1.5 rounded-2xl border p-5 text-left transition-[border-color,background-color,box-shadow] duration-200 ease-premium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne ${selected ? 'border-ink bg-ink text-cream shadow-card' : 'border-ink/15 bg-white text-ink hover:border-walnut/50 hover:bg-sand/40'}`} data-id="element-155" data-mp="gx0jnrcye3ke">
      <span className="flex w-full items-start justify-between gap-3" data-id="element-156" data-mp="3pdbv8zi7nn7s">
        <span className="font-serif text-xl font-light leading-snug" data-id="element-157" data-mp="3kdpeig36bou8">{label}</span>
        <span className={`mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 ease-premium ${selected ? 'border-champagne bg-champagne' : 'border-ink/25'}`} data-id="element-158" data-mp="3kftu3vafqcac">
          {selected && <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" data-id="element-159" data-mp="24qis02u9ps3j" />}
        </span>
      </span>
      {detail && <span className={`text-[12.5px] leading-relaxed ${selected ? 'text-cream/70' : 'text-stone-600'}`} data-id="element-160" data-mp="29okbupzipvg2">
          {detail}
        </span>}
      {hint && <span className={`mt-1 text-[11px] uppercase tracking-overline ${selected ? 'text-champagne' : 'text-walnut'}`} data-id="element-161" data-mp="20rte895bi8jd">
          {hint}
        </span>}
    </button>;
}